export default __webpack_public_path__ + "static/media/Quality.400fef7c.svg";